export default __webpack_public_path__ + "images/Tapclicks.7f8a694df9d3cabf42aa5e0eef7711f2.svg";